import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cx } from '@/lib/cx';

export interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'prefix'> {
  invalid?: boolean;
  /** 入力欄の前後に表示する単位・アイコン */
  prefix?: ReactNode;
  suffix?: ReactNode;
  /** 幅: 'xs'(6em) | 'sm'(10em) | 'md'(16em) | 'lg'(24em) | 'full' */
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'full';
}

/** 1 行テキスト入力。react-hook-form の register() をそのまま渡せる */
export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(function TextField(
  { invalid, prefix, suffix, width = 'full', className, type = 'text', ...rest },
  ref,
) {
  const input = (
    <input
      ref={ref}
      type={type}
      aria-invalid={invalid || undefined}
      className={cx('bs-input', !prefix && !suffix && `bs-w-${width}`, className)}
      {...rest}
    />
  );
  if (!prefix && !suffix) return input;
  return (
    <span className={cx('bs-affix', `bs-w-${width}`, invalid && 'is-invalid', rest.disabled && 'is-disabled')}>
      {prefix && <span className="bs-affix__item">{prefix}</span>}
      {input}
      {suffix && <span className="bs-affix__item">{suffix}</span>}
    </span>
  );
});
